export default{
  methods: {
    changeLangLabels(){
      var vm = this;
      if(!vm.areLabelsLoaded){
        //Add headers for DEM server to call
        //var myHeaders = new Headers();
        //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));

        var labelsURL = document.querySelector('#root').getAttribute('data-endpoint-labels');
        fetch(labelsURL, {
          //credentials: "include"//,
          //headers: myHeaders
        })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function (data) {
            if (data.header.success) {
              vm.$store.state.labels = data.data;
              vm.areLabelsLoaded = true;
              vm.$forceUpdate();
            }
            else {
              vm.$router.push('/');
            }
          })
          .catch(function () {
            vm.$router.push('/');
          })
      }
    },
    returnPath(relativePath){
      return ENV.assetsRoot + relativePath;
    },
    toggleClass(target, className){
      if (target.classList) {
        target.classList.toggle(className);
      }
      else {
        var classes = target.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
          classes.splice(existingIndex, 1);
        else
          classes.push(className);

        target.className = classes.join(' ');
      }
    },
    addClass(target, className){
      if (target.classList)
        target.classList.add(className);
      else
        target.className += ' ' + className;
    },
    removeClass(target, className){
      if (typeof target == 'String') {
        target = document.querySelector(target);
      }
      if (target.classList)
        target.classList.remove(className);
      else
        target.className = target.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    hasClass(el, className){
      if (el.classList)
        return el.classList.contains(className);
      else
        new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins.js